import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '../Icon';
import styles from './Checkbox.module.css';
export function Checkbox({ checked = false, indeterminate = false, label, onChange, disabled = false, ariaLabel, className, testIdIdentifier, }) {
    const baseTestId = testIdIdentifier ? `${testIdIdentifier}Checkbox` : 'Checkbox';
    const containerClasses = [styles.container, disabled && styles.disabled, className].filter(Boolean).join(' ');
    const inputRef = React.useRef(null);
    React.useEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);
    return (_jsxs("label", { className: containerClasses, "data-testid": `div${baseTestId}Container`, children: [_jsxs("div", { className: styles.checkboxWrapper, children: [_jsx("input", { ref: inputRef, type: 'checkbox', checked: checked, onChange: onChange, disabled: disabled, "aria-label": ariaLabel, "data-testid": `input${baseTestId}`, className: styles.checkbox }), checked && !indeterminate && (_jsx(Icon, { name: 'checkMark', className: styles.checkIcon, "data-testid": `icon${baseTestId}Check` }))] }), label && (_jsx("span", { className: styles.label, "data-testid": `text${baseTestId}Label`, children: label }))] }));
}
